module.exports = __webpack_public_path__ + "img/icon03.83daa305.png";